import { HttpClient } from '@wix/http-client';
import { calculateApiHostname } from './api.utils';
var httpClient = new HttpClient();
function getAppDataById(appDefId) {
    return httpClient
        .get("https://" + calculateApiHostname() + "/_api/marketplace-api/v1/web-solutions/" + appDefId)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
}
export { getAppDataById };
//# sourceMappingURL=app.js.map